<template>
  <v-container style="max-width: 450px" fill-height>
    <v-layout align-center row wrap>
      <v-flex xs12>
        <div class="pa-10">
          <h1 style="text-align: center" class="mb-10">VOD LIVE Video cms
            New Password
          </h1>
          <form>

            <v-text-field :rules="passwordRules" :error-messages="passwordErrorMessages" type="password"
              v-model="password" label="New Password" color="black" prepend-inner-icon="mdi-lock"
              @input="passwordValid = $refs.passwordRef.validate()" ref="passwordRef" />

            <v-text-field v-model="password_confirmation" label="Confirm Password" color="black"
              prepend-inner-icon="mdi-lock" type="password" :rules="[passwordConfirmationRule]"
              @input="passwordConfirmationValid = $refs.passwordConfirmationRef.validate()"
              ref="passwordConfirmationRef" />

            <v-row class="justify-center">
              <v-col cols="auto">
                <v-btn :disabled="!passwordValid || !passwordConfirmationValid" @click="resetPassword"
                  color="black lighten-1 text-capitalize" outlined elevation="0" class="mb-2">
                  Reset Password
                </v-btn>
              </v-col>
            </v-row>

            <v-snackbar v-model="snackbar" :timeout="10000" :color="snackbarError ? 'error' : 'success'" align-center>
              <v-icon color="white"> {{ snackbarIcon }} </v-icon> {{ snackbarText }}
            </v-snackbar>


          </form>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import UserApi from "@/api/user/UserApi";

export default {
  data() {
    return {
      snackbar: false,
      snackbarText: '',
      snackbarError: false,
      password: '',
      password_confirmation: '',
      passwordErrorMessages: '',
      snackbarIcon: 'mdi-close-circle',
      passwordValid: false,
      passwordConfirmationValid: false,
      message: '',
      email: this.$route.query.email || '',
      passwordRules: [
        v => !!v || 'Password is required',
        v => (v && v.length >= 8) || 'Password must be at least 8 characters long',
        v => /[A-Z]/.test(v) || 'Password must contain at least one uppercase letter',
        v => /[a-z]/.test(v) || 'Password must contain at least one lowercase letter',
        v => /\d/.test(v) || 'Password must contain at least one digit',
        v => /[-!$%^&*()_+|~=`{}\[\]:";'<>?,.\/]/.test(v) || 'Password must contain at least one special character',
      ],
      passwordConfirmationRule: v => v === this.password || 'Passwords do not match',
      rules: {
        required: (value) => !!value || "Required.",
      },
    };
  },
  watch: {
    password(newValue) {
      if (!newValue && !this.passwordErrorMessages) {
        this.passwordErrorMessages = '';
      }
    },
  },
  methods: {
    async resetPassword() {

      if (!this.password || !this.password_confirmation) {
        this.snackbarIcon = 'mdi-close-circle';
        this.snackbarText = 'Please fill in both password fields.';
        this.snackbar = true;
        return;
      }
      try {
        const data = {
          password: this.password,
          password_confirmation: this.password_confirmation,
          token: this.$route.params.token,
          email: this.email,
        }
        const response = await UserApi.resetPasswordApi(data);
        if (response.status === 0) {
          throw new Error(response.data.msg);
        }
        this.snackbarIcon = 'mdi-check-circle';
        this.snackbarText = "Your password has been successfully changed! Please try to log in to the homepage.";
        this.snackbar = true;
        this.password = '';
        this.password_confirmation = '';
        this.$refs.passwordRef.reset();
        this.$refs.passwordConfirmationRef.reset();
        setTimeout(() => {
          this.$router.push('/');
        }, 10000);

      } catch (error) {
        this.snackbarIcon = 'mdi-close-circle';
        this.snackbarError = error;
        this.snackbarText = error.message;
        this.snackbar = true;
      }
    }
  }
}
</script>
